// extracted by mini-css-extract-plugin
export var container = "index-module--container--6cef8";
export var list = "index-module--list--7b97c";